export const toMediaQuery = (minWidth, styles) => {
  return {
    [`@media (min-width: ${minWidth}px)`]: {
      ...styles
    }
  };
};

export const toMaxMediaQuery = (maxWidth, styles) => {
  return {
    [`@media (max-width: ${maxWidth}px)`]: {
      ...styles
    }
  };
};

function carinaFontReset(theme) {
  return {
    fontFamily: theme.font.base.family,
    fontStyle: 'normal',
    fontWeight: theme.font.base.weight.regular,
    letterSpacing: 'normal',
    lineHeight: theme.font.lineHeight.base,
    textIndent: 0,
    textShadow: 'none',
    textTransform: 'none'
  };
}

export { carinaFontReset };
